<template>
  <el-select :size="size"
             :value="value"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :clearable="clearable"
             :disabled="disabled"
             @change="change($event)"
             class="width100"
  >
    <el-option v-for="item in personDictionary.items" :key="item[personDictionary.valueKey]"
               :value="item[personDictionary.valueKey]" :label="item[personDictionary.textKey]"
    ></el-option>
  </el-select>
</template>

<script>
  import {PersonServer} from '@/api'
  import {Dictionary} from '@/util/common/dictionary'

  export default {
    name: "person-select",
    props: [
        'size', 'value', 'multiple', 'collapseTags', 'filterable', 'clearable', 'disabled',
        'search', 'departmentId', 'eqStatus', 'personuids', 'athubValueKey', 'athubTextKey'
    ],
    data() {
      return {
        _search: {},
        persons: [],
      };
    },
    computed: {
      personDictionary() {
        let items = this.persons;
        if (this.departmentId != null && this.departmentId !== '') {
          items = items.filter(e => String(e.department) === String(this.departmentId));
        }
        if (this.eqStatus != null && this.eqStatus !== '') {
          items = items.filter(e => String(e.status) === this.eqStatus);
        }
        if (this.personuids != null && this.personuids !== '') {
          let personuids = this.personuids.map(e => String(e));
          items = items.filter(e => personuids.indexOf(String(e.personuid)) !== -1);
        }
        let valueKey = 'personid', textKey = 'realname';
        if (this.athubValueKey !=  null && this.athubValueKey !== '') {
          valueKey = this.athubValueKey;
        }
        if (this.athubTextKey !=  null && this.athubTextKey !== '') {
          textKey = this.athubTextKey;
        }
        return new Dictionary({items: items, valueKey: valueKey, textKey: textKey});
      }
    },
    watch: {
      search: {
        immediate: true,
        deep: true,
        handler() {
          this._search = this.search || {};
        }
      },
      _search: {
        immediate: true,
        deep: true,
        handler() {
          this.loadPersons();
        },
      },
    },
    methods: {
      loadPersons() {
        PersonServer.personApi.list(this._search).then((res) => {
          if (res.data.code === 200) {
            this.persons = res.data.data;
          }
        })
      },
      change(event) {
        this.$emit('input', event);
        this.$emit('change', [event, this.personDictionary.getText(event)]);
      }
    }
  }
</script>

<style scoped>

</style>
